import React, {FC} from 'react'
//@ts-ignore
import LKGrid from 'shared/LKGrid'

import config from './LKGridConfig'
import { ReserveManProps } from 'src/features/LoanDetails/types.LoanDetails'

const ReserveMan: FC<ReserveManProps> = ({ data, instanceName, disabled }) => (
  <LKGrid instanceName={instanceName} rowData={data} disabled={disabled} {...config} />
)

export default ReserveMan
